<template>
    <page>
        <module>
            <view-list ref="view" work-type="21" selector :view-config="auth('b_aftersale_order_complaint_viewmanage')">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="售后工单号">
                            <c-select name="order_id"  async @search="searchAftersaleOrder" ></c-select>
                        </m-search-item>
                        <m-search-item label="投诉类型">
                            <c-select name="complaint_type" :options="complaintTypeDic"></c-select>
                        </m-search-item>
                        <m-search-item label="被投诉工程师">
                            <c-select name="complained_user_id" async @search="searchEngineer">
                                <template #option="{data, selected}">
                                    <select-option
                                            :name="data.name"
                                            :info="[
                                `${data.data.department_name || ''} | ${data.data.position_name || ''}`
                            ]"
                                            :selected="selected"
                                    ></select-option>
                                </template>
                            </c-select>
                        </m-search-item>
                        <m-search-item label="投诉日期">
                            <c-datetime name="complaint_date" range start-name="start_complaint_date" end-name="end_complaint_date" type="date" format="yyyy-MM-dd" placeholder="请选择投诉时间"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_aftersale_order_complaint_edit')" prepend-icon="tf-add" @click="$refs.orderComplaintEdit.open()">新增投诉</c-button>
                    <c-button v-if="auth('b_expense_reimbursement_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_expense_reimbursement_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <template #complaint_type="{data}">
                    <c-state dict="complaintTypeDic" :value="data.complaint_type"></c-state>
                </template>
                <template #issue_images="{data}">
                    <c-file-list :value="data.issue_images" size="mini"></c-file-list>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="200"
                        button-limit="3"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_aftersale_order_complaint_edit')" icon="tf-edit" @click="$refs.orderComplaintEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_order_complaint_edit')" icon="tf-delete" @click="removeComplaint(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--编辑网点信息弹窗-->
            <aftersale-order-complaint-edit ref="orderComplaintEdit" @resolve="$refs.view.$refs.list.update()"></aftersale-order-complaint-edit>
        </module>
    </page>
</template>

<script>
import aftersaleOrderComplaintEdit from "@/pages/aftersale/aftersale_order_complaint_edit.vue";
import {mapState} from "vuex";

export default {
    components: {aftersaleOrderComplaintEdit},
    computed: {
        // 获取dictName选项数据
        ...mapState(['complaintTypeDic']),
    },
    data() {
        return {
            defaultSearchData: {

            }
        }
    },

    methods: {
        /******删除投诉***********/
        removeComplaint(data){
            this.$confirm({
                message:'确认删除工单投诉吗？删除后不可恢复',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/aftersale/complaint/delete',
                        data: {id:data.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                message:'删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.view.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        },

        searchAftersaleOrder(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'AFTERSALE_ORDER',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        searchEngineer(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'SYSUSER',
                    is_engineer:1,
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

    }
}
</script>

<style lang="stylus" scoped>
</style>
